@if (billAccount && !loading) {
  <card [cardClasses]="'bill-account-detail-card'" tabindex="0">
    <div class="row md-flex items-center" card-header>
      <div class="column" [ngClass]="hasPendingPayment === true ? 'twelve md-six' : 'twelve'">
        <h2 class="overflow-hidden overflow-ellipsis" data-cy="billAccountName">
          {{ billAccountName }}
        </h2>
      </div>
      @if (hasPendingPayment === true) {
        <div class="column twelve md-six float-left md-float-right md-text-right">
          <span class="margin-0">
            <p data-cy="pendingPaymentDescription">{{ pendingPaymentDescription }}</p>
            <p data-cy="pendingPaymentDateFormat">{{ pendingPaymentDate | dateFormat }}</p>
          </span>
        </div>
      }
    </div>
    <div class="row flex wrap" card-content>
      <div class="column twelve md-seven details">
        <!-- Doesn't make sense to show it if it's the card title. -->
        @if (billAccount?.billingMethod === onlineBillingText) {
          <h4 data-cy="prettyBillingAccountNumber">
            Account: {{ billAccount.billAccountNumber | prettyBillingAcctNum }}
          </h4>
        }
        @if (billAccount.accountType) {
          <p data-cy="prettyBillingAccountMethod">
            {{ billAccount.accountType | prettyBillingMethod }} Account
          </p>
        }
        <!--
        If account is registered else where we do not have a way of finding out if the account
        was setup for autopay and the due date on that, hence we hide the autopay section completly
        -->
        <!-- DM: keeping this here for the time being in case of requirements change
        <h4
          class="margin-top-20"
          *ngIf="!billAccount.registeredElsewhere && !billAccount.enabledAFT && !!matchingAutopayRule"
          >
          Automatic Payments
        </h4>
        <p
          *ngIf="!billAccount.enabledAFT && !!matchingAutopayRule && !billAccount.registeredElsewhere"
          >
          <span>The </span>
          <span *ngIf="matchingAutopayRule?.paymentAmount !== 'FullPay'">minimum due</span>
          <span *ngIf="matchingAutopayRule?.paymentAmount === 'FullPay'">account balance</span>
          <span> will be paid </span>
          <span *ngIf="matchingAutopayRule?.daysBeforeDueDate === '0'">on the due date</span>
          <span *ngIf="matchingAutopayRule?.daysBeforeDueDate === '1'"
            >{{ matchingAutopayRule.daysBeforeDueDate }} day before the due date</span
            >
            <span *ngIf="matchingAutopayRule?.daysBeforeDueDate > 1"
              >{{ matchingAutopayRule.daysBeforeDueDate }} days before the due date</span
              >
            </p>
            -->
        @if (
          billAccount.enabledAFT !== true &&
          (!matchingAutopayRule || matchingAutopayRule === null) &&
          !billAccount.registeredElsewhere
        ) {
          <div>
            @if (
              billAccount?.billingMethod === onlineBillingText &&
              (roleService.isAuthorized('makeautopayrule_walkthrough') | async) === false
            ) {
              <p
                dsContent
                [contentPath]="'billing.noAutoPayImpersonatingMessage'"
                data-cy="noAutoPayImpersonatingMessage"
              ></p>
            }
          </div>
        }
        @if (billAccount.associated) {
          <div>
            @if (billAccount.policyList && billAccount.policyList.length > 0) {
              <h4 class="margin-top-20">Payment Covers</h4>
            }
            @for (policySummary of billAccount.policyList; track policySummary) {
              <p class="margin-bottom-20" data-cy="billAccountPolicyList">
                @if (policySummary.policyTypeForRouting && !isAdminApp) {
                  <span data-cy="billAccountPolicyNumber"
                    >Policy Number:
                    {{ policySummary.policyNumber | prettyPolicyNum }}
                    <br
                  /></span>
                }
                <!--AS: If we do not have a policy type then we do not have the policy details and we should
                      not build a anchor link to a 404 -->
                @if (!policySummary.policyTypeForRouting || isAdminApp) {
                  <span data-cy="billAccountPolicyNumberSummary">
                    Policy Number: {{ policySummary.policyNumber }}<br />
                  </span>
                }
                @for (risk of policySummary.risks; track risk) {
                  <span>
                    @if (policySummary.policyTypeForRouting && !isAdminApp) {
                      <a
                        [dsRouterLink]="[
                          '/policies',
                          policySummary.policyTypeForRouting,
                          policySummary.policyNumber
                        ]"
                        [queryParams]="!!risk.id ? { vehicleId: risk?.id } : undefined"
                      >
                        {{ risk.description | prettyRiskDescription }}</a
                      >
                    } @else {
                      {{ risk.name | prettyRiskDescription }}
                    }
                    <br />
                  </span>
                }
                @if (!policySummary?.riskDescriptionList?.length) {
                  <span>
                    {{ policySummary.policyType }}
                  </span>
                }
              </p>
            }
          </div>
        } @else {
          @if (billAccount.policyList && billAccount.policyList.length > 0) {
            <h4 class="margin-top-20" data-cy="paymentCoversPolicyList">Payment Covers</h4>
          }
          @for (policySummary of billAccount.policyList; track policySummary) {
            <p class="margin-bottom-20">
              <span data-cy="billAccountPrettyPolicyNumber"
                >Policy Number: {{ policySummary.policyNumber | prettyPolicyNum }}<br
              /></span>
              @for (risk of policySummary.riskDescriptionList; track risk) {
                <span data-cy="billAccountPrettyRiskDescription"
                  >{{ risk | prettyRiskDescription }}<br
                /></span>
              }
            </p>
          }
        }
        @if (tpiEnabled && thirdPartyInterest.length > 0) {
          <div class="row">
            <h4
              dsContent
              [contentPath]="'policy.thirdPartyInterest.billing.cardHeader'"
              class="margin-top-20"
              data-cy="billingThirdPartyInterestHeader"
            ></h4>
            <div class="margin-bottom-20">
              <p
                dsContent
                [contentPath]="'policy.thirdPartyInterest.billing.cardSubHeader'"
                [options]="{
                  multiple: thirdPartyInterest.length > 1
                }"
                data-cy="billingThirdPartyInterestSubHeader"
              ></p>
              @for (thirdParty of thirdPartyInterest; track thirdParty) {
                <p class="clamp" data-cy="billingThirdPartyInterestName">
                  {{ thirdParty.name | slice: 0 : 80 }}
                </p>
              }
            </div>
          </div>
        }
        @if (!isAdminApp && tpiRequestChangeEnabled && thirdPartyInterest.length > 0) {
          <div class="column twelve md-eight lg-nine">
            <button
              ds-button
              class="-outline-white row margin-0"
              (click)="onEditLender()"
              [attr.aria-label]="'View Account'"
              data-cy="editLenderInfo"
            >
              {{ editLenderBtnName }}
            </button>
          </div>
        }
      </div>
      <div class="column twelve md-five payment">
        <div class="row">
          <p
            class="column six"
            data-cy="billingAccountBalanceHeader"
            dsContent
            [contentPath]="'billing.unpaidBalance'"
          ></p>
          <div class="column six value">
            <p data-cy="billAccountBalance">
              {{ billAccount.accountBalance | strToFloat | currency: 'USD' : 'symbol' : '1.2-2' }}
            </p>
          </div>
          <hr aria-hidden="true" class="column twelve" />
          <!--Last Successful Payment-->
          @if (!!(lastSuccessfulPayment$ | async)) {
            <div class="row flex pad-top-10">
              <div class="column margin-right-5">
                <span class="icon-complete-circle payment-icon"></span>
              </div>
              <div class="column">
                @if (tpiEnabled && thirdPartyInterest.length > 0) {
                  <p
                    dsContent
                    [contentPath]="'policy.thirdPartyInterest.billing.paidByLender'"
                    data-cy="billingThirdPartyInterestPaidByLender"
                  ></p>
                } @else {
                  Paid
                }
                <p class="last-payment-date margin-top-0" data-cy="billingLastPayment">
                  Last Payment:
                  {{ (lastSuccessfulPayment$ | async).receivedDate | dateFormat: 'MM/DD/YYYY' }}
                </p>
              </div>
            </div>
          }
          <!--AutoPay-->
          @if (
            !billAccount.registeredElsewhere && !billAccount.enabledAFT && !!matchingAutopayRule
          ) {
            <div class="row flex pad-top-10 pad-bottom-10">
              <div class="column margin-right-5">
                <span class="icon-clock-repeat payment-icon"></span>
              </div>
              <div class="column">
                @if (!!matchingAutopayRuleDate && !!matchingAutopayRuleAmount) {
                  <ng-container data-cy="billingAutoPay"> AutoPay </ng-container>
                }
                @if (!(!!matchingAutopayRuleDate && !!matchingAutopayRuleAmount)) {
                  <ng-container data-cy="billingEnrolledInAutoPay">
                    Enrolled in AutoPay
                  </ng-container>
                }
                @if (!!matchingAutopayRuleDate) {
                  <p class="last-payment-date margin-top-0" data-cy="billingNextPaymentDate">
                    Next payment will be on:
                    {{ matchingAutopayRuleDate }}
                  </p>
                }
              </div>
              <span class="grow"></span>
              @if (!!matchingAutopayRuleAmount) {
                <div class="column" data-cy="billingNextPaymentAmount">
                  {{ matchingAutopayRuleAmount }}
                </div>
              }
            </div>
          }
        </div>
        @if (isClassicPastDue) {
          <div class="row card-pad">
            <div data-cy="billAccountPastDue" class="column six"><p>Past Due</p></div>
            <div class="column six value">
              <p data-cy="billAccountPastDueAmount">
                {{
                  billAccount?.minimumAmountDueBreakdown?.previousAmountDue
                    | strToFloat
                    | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </p>
            </div>
            <div class="row">
              <div class="column six billing-date">
                <p data-cy="billAccountPastDueDate">
                  {{
                    billAccount?.cancelLetterSent
                      ? 'Due now'
                      : 'Pay by ' + (billAccount?.billingStatement?.pastDueAmtDueDate | dateFormat)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="row card-pad">
            <div data-cy="billAccountCurrentDue" class="column six"><p>Current</p></div>
            <div class="column six value">
              <p data-cy="billAccountCurrentDueAmount">
                {{
                  billAccount?.minimumAmountDueBreakdown?.currentAmountDue
                    | strToFloat
                    | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </p>
            </div>
            <div class="row">
              <div class="column six billing-date">
                <p data-cy="billAccountCurrentDueDate">
                  Pay by {{ billAccount?.billingStatement?.currentAmtDueDate | dateFormat }}
                </p>
              </div>
            </div>
          </div>
        }
        <div [ngClass]="{ 'past-due-align': isClassicPastDue }" class="row minDue card-pad">
          <div
            class="pad-top-10"
            data-cy="billAccountTotalDue"
            [ngClass]="isClassicPastDue ? 'column seven past-plus-current' : 'column three'"
          >
            <p data-cy="billAccountPastDueCurrentDueMinDue">
              {{ isClassicPastDue ? 'Past Due + Current Due' : 'Min. Due' }}
            </p>
          </div>
          @if (!isClassicPastDue) {
            <div data-cy="billAccountMinDue" class="column nine value-total">
              <p>
                {{
                  billAccount.minimumAmountDue | strToFloat | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </p>
            </div>
          }
          @if (isClassicPastDue) {
            <div class="column five value-past-due-total">
              <p data-cy="billAccountPastPlusCurrentDueAmount">
                {{
                  (billAccount?.minimumAmountDueBreakdown?.previousAmountDue | strToFloat) +
                    (billAccount?.minimumAmountDueBreakdown?.currentAmountDue | strToFloat)
                    | currency: 'USD' : 'symbol' : '1.2-2'
                }}
              </p>
            </div>
          }
          <!--
              SK: System shall present due date for each billing account when minimum due is not zero.
              -->
        </div>
        @if (!isClassicPastDue) {
          <div class="row">
            @if (
              billAccount.minimumAmountDue !== 0 &&
              billAccount.paymentDueDate !== '0001-01-01T00:00:00.0-0600'
            ) {
              <div class="column twelve value due-by" data-cy="billAccountDueBy">
                <p>due by {{ billAccount.paymentDueDate | dateFormat }}</p>
              </div>
            }
          </div>
        }
        <div class="row">
          <!-- added link to view current bill pdf -->
          <div class="column twelve margin-top-20 pay-buttons">
            @if (billAccount.billingDocumentsList) {
              <a
                (click)="
                  openStatement(
                    documentApi +
                      'documents/' +
                      billAccount.billingDocumentsList[billAccount.billingDocumentsList.length - 1]
                        .documentId +
                      '?levelOfDetails=document&classification=Billing'
                  )
                "
                class="no-decoration ml-5"
                target="_blank"
                title="View Current Bil"
                data-cy="billAccountDetailViewCurrentBillLink"
              >
                View Current Bill
              </a>
            }
          </div>
          <div class="column twelve margin-top-20 pay-buttons">
            <!--
                Because each button has two routes we need multiple buttons to account for differing permissions.
                -->
            @if (showAutopayButton && billAccount?.billingMethod !== onlineBillingText) {
              <button
                ds-button
                authCheck
                [permissionName]="'registerbillacct_walkthrough'"
                [checkAction]="'disable'"
                class="-outline-white"
                data-cy="billAccountSetupAutopayButton"
                (click)="registerOrAutopay()"
                [attr.aria-label]="setupAutoPayBtnContent"
              >
                {{ setupAutoPayBtnContent }}
              </button>
            }
            @if (showAutopayButton && billAccount?.billingMethod === onlineBillingText) {
              <button
                ds-button
                authCheck
                [permissionName]="'makeautopayrule_walkthrough'"
                [checkAction]="'disable'"
                class="-outline-white"
                data-cy="billAccountSetupAutopayButton"
                (click)="registerOrAutopay()"
                [attr.aria-label]="setupAutoPayBtnContent"
              >
                {{ setupAutoPayBtnContent }}
              </button>
            }
            @if (showPayBillButton && billAccount?.billingMethod !== onlineBillingText) {
              <button
                ds-button
                authCheck
                [permissionName]="'registerbillacct_walkthrough'"
                [checkAction]="'disable'"
                class="-outline pad-left-40 pad-right-40"
                (click)="registerOrPay()"
                [attr.aria-label]="makePaymentBtnContent"
                data-cy="billAccountMakePaymentButton"
              >
                {{ makePaymentBtnContent }}
              </button>
            }
            @if (showPayBillButton && billAccount?.billingMethod === onlineBillingText) {
              <button
                ds-button
                authCheck
                [permissionName]="'makemyacctpayment_walkthrough'"
                [checkAction]="'disable'"
                class="-outline pad-left-40 pad-right-40"
                (click)="registerOrPay()"
                [attr.aria-label]="makePaymentBtnContent"
                data-cy="billAccountMakePaymentButton"
              >
                {{ makePaymentBtnContent }}
              </button>
            }
          </div>
        </div>
        @if (
          billAccount.registeredElsewhere ||
          billAccount.isExternalBam ||
          (matchedBillAccountNotificationState.loadPrefsError &&
            billAccount.billingMethod !== onlineBillingText)
        ) {
          <div class="row reg-elsewhere" data-cy="billAccountRegisteredElsewhere">
            <div class="column two text-right pad-right-10">
              <span class="icon-info color-blue"></span>
            </div>
            <div class="column ten">
              @if (billAccount.registeredElsewhere || billAccount.isExternalBam) {
                <span>
                  <span
                    dsContent
                    [contentPath]="'billing.managedElsewhere'"
                    data-cy="managedElsewhere"
                  ></span>
                  <span
                    dsPartnerContent
                    [brandContent]="'selectPrettyCusCareNumber'"
                    data-cy="getPrettyCusCareNumber"
                  ></span
                  >.
                </span>
              } @else {
                <span
                  dsContent
                  [contentPath]="'billing.preferencesNotLoaded'"
                  data-cy="preferencesNotLoaded"
                ></span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </card>
}
@if (!billAccount) {
  <div class="text-center">
    <h2 class="heading-main pseudo-icon icon-alert error-600-text"></h2>
    <h2 class="error-600-text" data-cy="billAccountCouldNotBeFound">
      Sorry, this billing account could not be found.
    </h2>
    <p class="caption">
      <a dsRouterLink="/overview" data-cy="returnToOverview">Return to the dashboard</a> and try
      navigating to your billing account from there.
    </p>
  </div>
}
@if (tpiEnabled && billAccount && !loading && thirdPartyInterest.length > 0) {
  <div class="disclaimer">
    <p class="pad-top-20" data-cy="billAccountDisclaimer">{{ billAccountDisclaimer }}</p>
  </div>
}
